/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable react/no-danger */
import React, { FC } from 'react'
import { TemporarilyUnavailablePageView } from '@views/error-page/@x/tsp-page'
import { TspPaymentStep } from '@entities/payment'
import { CommissionDataByServiceIdType } from '@entities/denomination'
import { SteamAccountPayee, SteamAccountVoucher, useCyberStore } from '@entities/tsp'
import UnreleasedServicePageView from './UnreleasedServicePageView'
import SteamFormPageView from './SteamFormPageView'
import OtpPcekPageView from './OtpPcekPageView'

interface SteamPageViewProps {
  h1: string
  payee: SteamAccountPayee
  countryVouchers: { country: string; icon: string }[]
  denominationsByCountry: Record<string, SteamAccountVoucher[]>
  commissionData: CommissionDataByServiceIdType
}

const SteamPageView: FC<SteamPageViewProps> = ({
  h1,
  payee,
  countryVouchers,
  denominationsByCountry,
  commissionData,
}) => {
  const { step } = useCyberStore()

  // useFromOtp()

  // useEffect(() => {
  //   if (router.query?.id !== 'steam') {
  //     setIsPromocodeActivated(false)
  //   }
  // }, [router.query?.id])

  if (payee.customParams?.isDisabled) {
    return <UnreleasedServicePageView />
  }

  return {
    [TspPaymentStep.SERVICES_FORM]: (
      <SteamFormPageView
        payee={payee}
        h1={h1}
        countryVouchers={countryVouchers}
        denominationsByCountry={denominationsByCountry}
        commissionData={commissionData}
      />
    ),
    [TspPaymentStep.NOT_TCP]: <TemporarilyUnavailablePageView />,
    [TspPaymentStep.PAYMENT_OTP]: <OtpPcekPageView showVouchersForm={false} payee={payee} />,
  }[step]
}

export default SteamPageView
